import React, { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Grid,
  Nav,
  Row,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  Message,
  toaster,
  useToaster,
  FlexboxGrid,
  Checkbox,
  Input
} from 'rsuite';
import globalIP from '../../GlobelIP';
import MenuIcon from '@rsuite/icons/Menu';
import { Link } from 'react-router-dom';
import { ControlCol, CustomInput } from '../Costing/costing-page';
import { useFormik } from 'formik';
import ugr from '@/UGRoute';

const AttributeSetup = () => {
  const ip = globalIP;
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };

  // \\\\\\\\\\\\\\\\\ CONTENNT--->1 START//////////////////////////
  const [cheadata, setCheadata] = useState<{
    attributes: {
      gst?: string;
      laison?: string;
      testing?: string;
      other?: string;
      overhead?: string;
    };
  }>({ attributes: {} });
  const [cheadId, setCheadId] = useState<number | undefined>(undefined);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const pageResponse = await fetch(`${ip}/api/costingheads?populate=*`);
    const pageJson = await pageResponse.json();

    if (pageJson.data[0]) {
      setCheadata(pageJson.data[0]);
      setCheadId(pageJson.data[0]?.id);
    } else {
      setCheadata({ attributes: {} });
    }
  };

  const [openSet, setOpenSet] = useState(false);
  useEffect(() => {
    formik.setValues({
      ...formik.values,
      gst: cheadata?.attributes?.gst || '',
      laison: cheadata?.attributes?.laison || '',
      testing: cheadata?.attributes?.testing || '',
      other: cheadata?.attributes?.other || '',
      overhead: cheadata?.attributes?.overhead || ''
    });
  }, [cheadata]);

  const formik = useFormik({
    initialValues: {
      gst: '',
      laison: '',
      testing: '',
      other: '',
      overhead: ''
    },
    onSubmit: async values => {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          gst: values.gst,
          laison: values.laison,
          testing: values.testing,
          other: values.other,
          overhead: values.overhead
        })
      );

      if (cheadId) {
        const response = await fetch(`${ip}/api/costingheads/${cheadId}`, {
          method: 'PUT',
          body: formData
        });
        if (response.ok) {
          await fetchData();

          toaster.push(
            <Message showIcon type="success">
              Data Updated Successfully.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          console.error('Failed to update data');
        }
      } else {
        const response = await fetch(`${ip}/api/costingheads`, {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          await fetchData();

          toaster.push(
            <Message showIcon type="success">
              Data Saved Successfully.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          console.error('Failed to save data');
        }
      }
    }
  });

  // \\\\\\\\\\\\\\\\\ CONTENNT--->1 END////////////////////////////
  // \\\\\\\\\\\\\\\\\ CONTENNT--->2 START//////////////////////////

  const [label, setLabel] = useState({
    Category: 'Category',
    ProductType: 'Product Type',
    AliasCode: 'Alias Code',
    ProductName: 'Product Name',
    Description: 'Description',
    Sizeunit: 'Sizeunit',
    length: 'length',
    width: 'Width',
    height: 'Height',
    cbm: 'CBM',
    finish: 'Finish',
    color: 'Color',
    HSN: 'HSN',
    NetWgt: 'NetWgt',
    GrossWgt: 'GrossWgt',
    MOQ: 'MOQ',
    Currency: 'Currency',
    CurRate: 'CurRate',
    SalePrice: 'SalePrice',
    SalePriceINR: 'SalePriceINR',
    ProductDesigner: 'Product Designer',
    MadeBy: 'Made By',
    ProductRemark: 'Product Remark',
    searchKeyword: 'Search Keyword',
    BuyerName: 'Buyer Name',
    BuyerSku: 'Buyer Sku',
    BuyerRemark: 'Buyer Remark',
    MaterialName: 'Material Name',
    Shape: 'Shape',
    Collection: 'Collection',
    Season: 'Season',
    P_Technique: 'P_Technique',
    SizeRange: 'SizeRange'
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      // setLabel1(json.data);
      const extractedData = json.data[0].attributes;
      setLabel(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleEditClick = () => {
    setIsEditing(prevState => !prevState);
  };

  const handleInputChange = (fieldName, value) => {
    setLabel(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };
  const toaster = useToaster();

  const handleSave = async () => {
    try {
      const isEmpty = Object.values(label).some(value => value === '');
      if (isEmpty) {
        toaster.push(
          <Message showIcon type="error">
            Please fill all fields.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else {
        const fetchResponse = await fetch(`${ip}/api/product-labels`);
        if (fetchResponse.ok) {
          const json = await fetchResponse.json();

          if (json && json.data && json.data.length > 0 && json.data[0]) {
            const putResponse = await fetch(`${ip}/api/product-labels/${json.data[0].id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                data: label
              })
            });

            if (putResponse.ok) {
              fetchDatalabel();
              toaster.push(
                <Message showIcon type="success">
                  Updated Successfully.
                </Message>,
                { placement: 'topEnd' }
              );
            } else {
              console.error('! Data is not Updated Successfully');
            }
          } else {
            const postResponse = await fetch(`${ip}/api/product-labels`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                data: label
              })
            });

            if (postResponse.ok) {
              fetchDatalabel();
              toaster.push(
                <Message showIcon type="success">
                  Data is Saved.
                </Message>,
                { placement: 'topEnd' }
              );
            } else {
              console.error(' Data is not Saved ');
            }
          }
        }

        setIsEditing(false);
      }
    } catch (error) {
      console.error('Error saving/updating label:', error);
      toaster.push(
        <Message showIcon type="error">
          Error: {error.message}
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  const renderField = (fieldName, labelValue) => (
    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
      {/* {isEditing ? ( */}
      <label>{fieldName}</label>
      <Input value={labelValue} onChange={value => handleInputChange(fieldName, value)} />
      {/* ) : (
      <span>{labelValue}</span>
    )} */}
    </FlexboxGrid.Item>
  );
  // \\\\\\\\\\\\\\\\\ CONTENNT--->2 END//////////////////////////
  // \\\\\\\\\\\\\\\\\ CONTENNT--->3 START//////////////////////////
  const [currencyD, setCurrencyD] = useState([]);

  const [currencyFormData, setCurrencyFormData] = useState({
    currencyname: '',
    exchangerate: 0
  });

  useEffect(() => {
    fetchDataCur();
  }, []);
  const fetchDataCur = async () => {
    try {
      const response = await fetch(`${ip}/api/currency-masters`);
      const json = await response.json();
      // const extractedData = json.data[0].attributes;
      setCurrencyD(json.data || []);
      // console.log("extractedData-------" ,json);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const submit = async () => {
    try {
      const payload = {
        data: { ...currencyFormData }
      };

      const response = await fetch(`${ip}/api/currency-masters`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        await fetchDataCur();
        // console.log('Currency Data:', currencyD);

        toaster.push(
          <Message showIcon type="success">
            Data is Saved.
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.error('Failed to save data:', await response.text());
      }
    } catch (error) {
      console.error('Error in submit:', error);
    }

    // Reset the form
    setCurrencyFormData({
      currencyname: '',
      exchangerate: 0
    });
  };

  const handleInputChangeC = (inputName, value, defaultValue) => {
    setCurrencyFormData({
      ...currencyFormData,
      ...(value ? { [inputName]: value } : { [inputName]: defaultValue })
    });
  };

  const handleDelete = async (id: number | undefined) => {
    if (id !== undefined) {
      try {
        const response = await fetch(`${ip}/api/currency-masters/${id}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          setCurrencyD(currencyD.filter(item => item.id !== id));
          toaster.push(
            <Message showIcon type="success">
              Currency deleted successfully.
            </Message>,
            { placement: 'topEnd' }
          );
        } else {
          console.error('Failed to delete data:', await response.text());
          toaster.push(
            <Message showIcon type="error">
              Failed to delete currency.
            </Message>,
            { placement: 'topEnd' }
          );
        }
      } catch (error) {
        console.error('Error in handleDelete:', error);
      }
    }
  };

  // \\\\\\\\\\\\\\\\\ CONTENNT--->3 END//////////////////////////
  // \\\\\\\\\\\\\\\\\ CONTENNT--->4 START//////////////////////////

  const [filterData, setFilterData] = useState([
    {
      FilterName: 'Category',
      filterstatus: false
    },
    {
      FilterName: 'Color',
      filterstatus: false
    },
    {
      FilterName: 'Finish',
      filterstatus: false
    },
    {
      FilterName: 'ProName',
      filterstatus: false
    },
    {
      FilterName: 'BuyerStyle',
      filterstatus: false
    },
    {
      FilterName: 'BuyerName',
      filterstatus: false
    },
    {
      FilterName: 'AliasCode',
      filterstatus: false
    },
    {
      FilterName: 'Searchk',
      filterstatus: false
    },
    {
      FilterName: 'PDesign',
      filterstatus: false
    },
    {
      FilterName: 'MadeBy',
      filterstatus: false
    },
    {
      FilterName: 'HSN',
      filterstatus: false
    },
    {
      FilterName: 'ProductType',
      filterstatus: false
    }
  ]);
  const [fildata, setFilData] = useState([]);
  useEffect(() => {
    fetchDatafil();
  }, []);
  const fetchDatafil = async () => {
    try {
      const response = await fetch(`${ip}/api/mstfilters`);
      const json = await response.json();
      setFilData(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const submit2 = async () => {
    try {
      if (fildata.length === 0) {
        const promises = filterData.map(async filter => {
          const formData = new FormData();
          formData.append('data', JSON.stringify(filter));

          const response = await fetch(`${ip}/api/mstfilters`, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            console.log('Filter Data Saved:', filter);
          } else {
            console.error('Failed to save filter:', filter.FilterName, await response.text());
          }
        });
        await Promise.all(promises);
        toaster.push(
          <Message showIcon type="success">
            All Selected Filters Data are Saved.
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        toaster.push(
          <Message showIcon type="success">
            Filters Already Saved.
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error in submit:', error);
    }
  };

  // \\\\\\\\\\\\\\\\\ CONTENNT--->4 END//////////////////////////
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar selection-head " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="row" alignItems="flex-start" spacing={221}>
                <h3 className="title">Attributes Setup</h3>
                <div onClick={() => setOpenSet(!openSet)}>
                  <MenuIcon className="burgerMenu1" />
                </div>
              </Stack>

              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Attributes Setup</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>

            <Stack className={openSet ? 'mange-item' : 'mange-search'}>
              <Nav
                appearance="tabs"
                activeKey={activeKey}
                onSelect={handleNavSelect}
                style={{ display: 'flex', gap: '20px' }}
                className="mstr-nav"
              >
                <Nav.Item eventKey="content1">
                  <b>Costing Head</b>
                </Nav.Item>
                <Nav.Item eventKey="content2">
                  <b>Product Attributes</b>
                </Nav.Item>
                <Nav.Item eventKey="content3">
                  <b>Currency</b>
                </Nav.Item>
                <Nav.Item eventKey="content4">
                  <b>Filters Master</b>
                </Nav.Item>
              </Nav>
            </Stack>
          </Stack>
        </Stack>
        <Divider className="divide" />

        <Panel>
          {activeKey == 'content1' && (
            <Panel className="row row1">
              <form onSubmit={formik.handleSubmit}>
                <Grid fluid>
                  <Row>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <ControlCol
                        label="GST %"
                        control={
                          <CustomInput
                            placeholder="0.00"
                            name="gst"
                            value={formik.values.gst}
                            onChange={value => formik.setFieldValue('gst', value)}
                          />
                        }
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <ControlCol
                        label="Laison %"
                        control={
                          <CustomInput
                            placeholder="0.00"
                            name="laison"
                            value={formik.values.laison}
                            onChange={value => formik.setFieldValue('laison', value)}
                          />
                        }
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <ControlCol
                        label="Testing %"
                        control={
                          <CustomInput
                            placeholder="0.00"
                            name="testing"
                            value={formik.values.testing}
                            onChange={value => formik.setFieldValue('testing', value)}
                          />
                        }
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <ControlCol
                        label="Other %"
                        control={
                          <CustomInput
                            placeholder="0.00"
                            name="other"
                            value={formik.values.other}
                            onChange={value => formik.setFieldValue('other', value)}
                          />
                        }
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <ControlCol
                        label="OverHead %"
                        control={
                          <CustomInput
                            placeholder="0.00"
                            name="overhead"
                            value={formik.values.overhead}
                            onChange={value => formik.setFieldValue('overhead', value)}
                          />
                        }
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px', paddingTop: '14px' }}>
                      <Button size="sm" color="cyan" appearance="primary" type="submit">
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Grid>
              </form>
            </Panel>
          )}

          {activeKey === 'content2' && (
            <>
              {/* <Button appearance="subtle" active onClick={handleEditClick}>
                {isEditing ? 'Close' : 'Edit'}
              </Button> */}
              <FlexboxGrid justify="start" style={{ gap: '15px', marginTop: '10px' }}>
                {renderField('Category', label.Category)}
                {renderField('ProductType', label.ProductType)}
                {renderField('AliasCode', label.AliasCode)}
                {renderField('ProductName', label.ProductName)}
                {renderField('Description', label.Description)}
                {renderField('Sizeunit', label.Sizeunit)}
                {renderField('length', label.length)}
                {renderField('width', label.width)}
                {renderField('height', label.height)}
                {renderField('cbm', label.cbm)}
                {renderField('finish', label.finish)}
                {renderField('color', label.color)}
                {renderField('HSN', label.HSN)}
                {renderField('NetWgt', label.NetWgt)}
                {renderField('GrossWgt', label.GrossWgt)}
                {renderField('MOQ', label.MOQ)}
                {renderField('Currency', label.Currency)}
                {renderField('CurRate', label.CurRate)}
                {renderField('SalePrice', label.SalePrice)}
                {renderField('SalePriceINR', label.SalePriceINR)}
                {renderField('ProductDesigner', label.ProductDesigner)}
                {renderField('MadeBy', label.MadeBy)}
                {renderField('ProductRemark', label.ProductRemark)}
                {renderField('searchKeyword', label.searchKeyword)}
                {renderField('BuyerName', label.BuyerName)}
                {renderField('BuyerSku', label.BuyerSku)}
                {renderField('BuyerRemark', label.BuyerRemark)}
                {renderField('MaterialName', label.MaterialName)}
                {renderField('Shape', label.Shape)}
                {renderField('Collection', label.Collection)}
                {renderField('Season', label.Season)}
                {renderField('P_Technique', label.P_Technique)}
                {renderField('SizeRange', label.SizeRange)}
              </FlexboxGrid>
              <Stack justifyContent="flex-end" className="setting-mstr-panel">
                {/* {isEditing && ( */}
                <Button
                  appearance="primary"
                  color="cyan"
                  onClick={handleSave}
                  className="mstr-btn-setting1"
                >
                  Save
                </Button>
                {/* )} */}
              </Stack>
            </>
          )}

          {activeKey === 'content3' && (
            <Grid fluid>
              <Row>
                <Col xs={8} style={{ marginBottom: '15px' }}>
                  <label>Currency Name</label>
                  <Input
                    id="currencyname"
                    name="currencyname"
                    value={currencyFormData.currencyname}
                    onChange={value => handleInputChangeC('currencyname', value, '')}
                  />
                </Col>
                <Col xs={8} style={{ marginBottom: '15px' }}>
                  <label>Exchange Rate</label>
                  <Input
                    id="exchangerate"
                    name="exchangerate"
                    type="number"
                    value={currencyFormData.exchangerate}
                    onChange={value => handleInputChangeC('exchangerate', value, 0)}
                  />
                </Col>
                <Col xs={8} style={{ marginBottom: '15px', paddingTop: '14px' }}>
                  <Button
                    appearance="primary"
                    color="cyan"
                    onClick={submit}
                    className="mstr-btn-setting1"
                  >
                    Save
                  </Button>
                </Col>
              </Row>

              {Array.isArray(currencyD) &&
                currencyD.map((currency, index) => (
                  <Row key={index}>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <label>Currency Name</label>
                      <Input
                        id="currencyname"
                        name="currencyname"
                        value={
                          currency && currency.attributes && currency.attributes.currencyname
                            ? currency.attributes.currencyname
                            : ''
                        }
                        onChange={value => handleInputChangeC('currencyname', value, 0)}
                        readOnly
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px' }}>
                      <label>Exchange Rate</label>
                      <Input
                        id="exchangerate"
                        name="exchangerate"
                        value={
                          currency && currency.attributes && currency.attributes.exchangerate
                            ? currency.attributes.exchangerate
                            : ''
                        }
                        onChange={value => handleInputChangeC('exchangerate', value, 0)}
                        readOnly
                      />
                    </Col>
                    <Col xs={8} style={{ marginBottom: '15px', paddingTop: '14px' }}>
                      <Stack style={{ gap: '8px' }}>
                        <Button
                          appearance="primary"
                          color="red"
                          onClick={() => handleDelete(currency.id)}
                          className="mstr-btn-setting1"
                        >
                          Delete
                        </Button>
                      </Stack>
                    </Col>
                  </Row>
                ))}
            </Grid>
          )}

          {activeKey === 'content4' && (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit2}
              className="mstr-btn-setting1"
            >
              Save
            </Button>
          )}
        </Panel>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default AttributeSetup;
